export enum Role {
    SuperAdmin = 1,
    Assigner = 2,
    Approver = 3,
    Checker = 4,
    Maker = 5,

}

export const RoleArray = [1, 2, 3, 4, 5];